import { MACHINE_SERVICE_TYPES } from '../../constants';

// everything except "RESTOCK"
export const shouldMachineBeRepaired =
    machineServiceType => [MACHINE_SERVICE_TYPES.REPAIR, MACHINE_SERVICE_TYPES.RESTOCK_AND_REPAIR].includes(machineServiceType);
